import type { EnumUnion } from "@dresscode-frontend/utility-types";

// TODO: 今はまだ何も決まってないので暫定で１つおいておく。将来的に台帳作成時に色々決まると思われる
export const CertificationType = {
  CERTIFICATION: "CERTIFICATION",
} as const;
export type CertificationType = EnumUnion<typeof CertificationType>;
